import { apiGet } from '../../api'

export const reject_application = query => {
  return apiGet({
    endpoint: `application/reject_application?id=${query}`
  })
}
